import React, {useState,useEffect,memo} from 'react';
import { withRouter } from "react-router-dom"
import { LinkContainer } from 'react-router-bootstrap';
import { isSet } from '../../Utils/CommonFunctions';
import {getWindowIcons,getProfileAuthorities,getUserAuthorities,getCurrentModuleId,clearGoBackURL, getUserInfo, PROFILE_AUTHORITIES_UPDATED_EVENT} from '../../Utils/UserFunctions';
import Wrp from "../../hoc/Wrp/Wrp";
import ReminderList from './ReminderList';
import Icons from "../Icons/Icons";
import WindowIcons from '../Icons/WindowIcon';
import $ from 'jquery';
import ProfileService from '../../services/ProfileService';
import { connect } from 'react-redux';
import { loadPagesConfigAction, clearHistoryPageFlowsAction } from '../../store/actions/PagesAction';
const OTHER_MENUS = [{
	name:'Reports',
	icon:"Reports",
	class:`nav-item tab_focus svgIconFill`,
	url:'/reports',
	// Gate by profile View + Show-in-menu using stable system window name
	permissionWindowName:'Reports'
},{
	name:'Documents',
	icon:"Contacts",
	class:`nav-item tab_focus svgIconFill`,
	url:'/documents',
	permissionWindowName:'Documents'
}]

const SPECIAL_PERMISSION_MENU_WINDOWS = OTHER_MENUS
	.map((m) => (m.permissionWindowName || '').toLowerCase())
	.filter(Boolean);

const isPermissionTruthy = (val) => val === true || val === 'true' || val === 1 || val === '1';

const windowMatchesPermission = (windowObj, windowName) => {
	if (!windowObj || !windowName) {
		return false;
	}
	const nameLower = windowName.toString().toLowerCase();
	const winName = windowObj.window_name?.toString().toLowerCase();
	return !!nameLower && winName === nameLower;
};

/**
 * Resolve View + is_show_in_menu for OTHER_MENUS (Reports/Documents).
 * Prefer profile permissions (canonical). Reports/Documents usually are not in
 * layout-based menuData / userAuthorities, so those are fallbacks only.
 * While profile session is still loading, keep visible (pre-gating behavior) to
 * avoid a login race that permanently hides these items.
 */
const hasWindowMenuAccessByName = (windowName, menuList = []) => {
	if (!windowName) {
		return false;
	}

	const resolveAccess = (windowObj) => {
		if (!windowObj) {
			return null;
		}
		const authorities = isSet(
			windowObj.window_authorities?.length ? windowObj.window_authorities : windowObj.profiles,
			[]
		);
		const viewAuthority = authorities.find((item) => item.authority_name === 'View');
		// Missing View authority ⇒ treat as no access once a window record exists
		const hasView = viewAuthority ? isPermissionTruthy(viewAuthority.is_selected) : false;
		const showInMenu = windowObj.is_show_in_menu !== undefined && windowObj.is_show_in_menu !== null
			? isPermissionTruthy(windowObj.is_show_in_menu)
			: true;
		return hasView && showInMenu;
	};

	const profileAuthorities = getProfileAuthorities();
	const profileWindows = profileAuthorities?.data?.windows;
	const profileLoaded = Array.isArray(profileWindows);

	if (profileLoaded) {
		const fromProfile = profileWindows.find((w) => windowMatchesPermission(w, windowName));
		const profileAccess = resolveAccess(fromProfile);
		if (profileAccess !== null) {
			return profileAccess;
		}
		// Profile loaded but no permission row for this special window ⇒ hide
		return false;
	}

	const fromMenu = isSet(menuList, []).find((w) => windowMatchesPermission(w, windowName));
	const menuAccess = resolveAccess(fromMenu);
	if (menuAccess !== null) {
		return menuAccess;
	}

	let fromUserAuth = null;
	const userAuthorities = getUserAuthorities();
	if (userAuthorities?.data) {
		userAuthorities.data.forEach((item) => {
			isSet(item.windows, []).forEach((win) => {
				if (windowMatchesPermission(win, windowName)) {
					fromUserAuth = win;
				}
			});
		});
	}
	const userAccess = resolveAccess(fromUserAuth);
	if (userAccess !== null) {
		return userAccess;
	}

	// Profile not in session yet (cleared on login, async reload) ⇒ keep showing
	return true;
};

const LeftNav = memo((props) => {
	const [toggleSideBarShow, setToggleSideBarShow] = useState(false);
	const [toggleLeftMenuShow, setToggleLeftMenuShow] = useState(false);
	const [leftMenuData,setLeftMenuData] = useState([]);
	const [dataJSONPayload,setDataJSONPayload] = useState({
		"windowAccess": {
			"globalRestrictedWindows": [],
			"profile": "Community Partners",
			"restrictedWindows": []
		}
	});
	const [reminderMessage,setReminderMessage] = useState(null);
	const [leftMoreMenuData,setLeftMoreMenuData] = useState([]);
	// Bumped when profile localStorage is written so OTHER_MENUS re-evaluate View/Show-in-menu
	const [profileMenuTick, setProfileMenuTick] = useState(0);

	
	const userAuthorities = getUserAuthorities();
	const currentModuleId = getCurrentModuleId();
	let userDefaultMod = '';
	let userModule = (userAuthorities != null && userAuthorities.data) ? userAuthorities.data.map((arr,i) => {
		if(arr.id === currentModuleId)
		{
			userDefaultMod = arr.module_name;
		}
	}):[];
	const currentURL = props.history.location.pathname;
	const getURLDetails = isSet(currentURL,'').split('/');
	
	useEffect(()=>{
		fetch(`/data.json`)
		.then((response) => response.json())
		.then((jsonData) => { setDataJSONPayload(jsonData) })
		.catch((error) => console.error('Error fetching JSON:', error));
	},[]);

	useEffect(() => {
		const onProfileUpdated = () => setProfileMenuTick((tick) => tick + 1);
		window.addEventListener(PROFILE_AUTHORITIES_UPDATED_EVENT, onProfileUpdated);
		return () => window.removeEventListener(PROFILE_AUTHORITIES_UPDATED_EVENT, onProfileUpdated);
	}, []);

	useEffect(()=>{
		updateMenuData();
	},[props.menuData,props.showItems,dataJSONPayload,profileMenuTick]);
	
	useEffect(()=>{
		updateMenuData();
	},[props.match.params]);

	const updateMenuData = ()=>{
		let ii = 0;
		let moreMenuData = [];
		let leftMenuData = [];
		let restrictedMenus = [];
		const {windowAccess} = dataJSONPayload;
		restrictedMenus = isSet(windowAccess.globalRestrictedWindows,[]);
		try{
			if(getUserInfo().data.profile_name===isSet(windowAccess.profile,'')){
				restrictedMenus = restrictedMenus.concat(isSet(windowAccess.restrictedWindows,[]));
			 }
		}catch(e){

		}
		
		let menuWindowList = isSet(props.menuData,[]);
		//Menu Sorting based on display priority
		// menuWindowList.sort((a, b) => (a.display_priority > b.display_priority) ? 1 : -1);
		const sortedMenuList = [...menuWindowList].sort((a, b) => {
                  return a.display_priority - b.display_priority;
            });
		const seenMenuKeys = new Set();
		const getMenuKey = (menuItem) => {
			// Pages menus share window_id; use org_window_id so each pages config stays visible
			if (menuItem?.org_window_id) {
				return `org:${menuItem.org_window_id}`;
			}
			return `win:${menuItem.window_id}`;
		};
		//Menu Iterate
		// console.log('menuWindowList',menuWindowList);
		sortedMenuList.map((arr,i) => {
			if(restrictedMenus.indexOf(arr.window_name.toString().toLowerCase())!==-1){
				return false;
			}
			// Reports/Documents are rendered via OTHER_MENUS (/reports, /documents). Skip here to avoid duplicate + wrong layout navigation.
			if(SPECIAL_PERMISSION_MENU_WINDOWS.includes(arr.window_name?.toString().toLowerCase())){
				return false;
			}
			const menuKey = getMenuKey(arr);
			if (seenMenuKeys.has(menuKey)) {
				return false;
			}
			seenMenuKeys.add(menuKey);
			// Menu: View permission AND show-in-menu flag (profile Hide/Show)
			const viewAuthority = isSet(arr.profiles, []).find((item) => item.authority_name === 'View');
			const hasView = viewAuthority ? isPermissionTruthy(viewAuthority.is_selected) : false;
			const showInMenu = arr.is_show_in_menu !== undefined && arr.is_show_in_menu !== null
				? isPermissionTruthy(arr.is_show_in_menu)
				: true;
			let isAllowAccess = hasView && showInMenu;
   			let actClass 		= '';
			let actClassMore 	= '';
			let svgIcons = isSet(getWindowIcons(),[]);
			let sourceImage =   "";
			let htmlCode = "";
			svgIcons.map((item,i)=>{
				if(item.id===arr.window_icon){
					htmlCode = item.html_code;
					sourceImage= 'data:image/svg+xml;base64,'+item.svg_icon;	
				}
			});						
			if(getURLDetails[1]!=='settings' && getURLDetails[2] === arr.window_name){
				actClass = 'active'; 
				actClassMore= 'd-flex active align-items-center'; 
			}
			
			if(isAllowAccess === true || isAllowAccess === 'true'){
				if(ii < props.showItems){
					leftMenuData.push(
						   <LinkContainer to="#" key={menuKey}>
							   <li onClick={goToWindowList.bind(this,arr,props)} className={`nav-item tab_focus svgIconFill ${actClass}`} to={arr.window_name}>
							   <a className="cursor-pointer" data-title={arr.window_name}>
									   {/* <Icons iconType={arr.window_name} /> */}
									   {isSet(arr.window_icon,null)!==null?(!arr.system_icon?
									<img src={sourceImage}  width='18' height='18' />
									// <div className="Container" dangerouslySetInnerHTML={{__html: htmlCode}}></div>
								   :<WindowIcons  windowIcon={arr.window_icon} size={18} />):
									<Icons iconType={arr.window_name} />
									 } 
   
									   <div className={toggleLeftMenuShow === false ? "windowName" : "windowName aaa"}> {arr.window_name} </div>
								   </a>
							   </li>
						   </LinkContainer>
					   )
				}else{
					   moreMenuData.push(
						   <LinkContainer to="#" key={menuKey}>
							   <div className={`item ${actClassMore}`} id={'winId_'+menuKey} onClick={goToWindowList.bind(this,arr,props)} to={arr.window_name} title={arr.window_name}>
								   {/* <Icons iconType={arr.window_name} /> */}
								   {isSet(arr.window_icon,null)!==null?(!arr.system_icon?
									<img src={sourceImage}  width='18' height='18' />
									// <div className="Container" width='18' height='18' dangerouslySetInnerHTML={{__html: htmlCode}}></div>

								   :<WindowIcons  svgIcons = {svgIcons} isSystemIcon={arr.system_icon} size={18} windowIcon={arr.window_icon}/>):
									<Icons iconType={arr.window_name} />
									 } 
								   <span className="pl-2 text-truncate">{arr.window_name}</span>	
							   </div>							
						   </LinkContainer>
					   )	
				}
			ii++;		
			}			   
		});
		OTHER_MENUS.map((arr,i) => {
			let actClass = '';
			let actClassMore = '';	
			let sourceImage =   "";
			let htmlCode = "";
			if(restrictedMenus.indexOf(arr.name.toString().toLowerCase())!==-1){
				return false;
			}
			// Reports/Documents: show/hide from profile View + Show-in-menu (same as other windows)
			if(arr.permissionWindowName && !hasWindowMenuAccessByName(arr.permissionWindowName, menuWindowList)){
				return false;
			}
			let svgIcons = isSet(getWindowIcons(),[]);
			svgIcons.map((item,i)=>{
				if(item.id===arr.window_icon){
					// console.log("sItem",item);
					htmlCode = item.html_code;
					sourceImage= 'data:image/svg+xml;base64,'+item.svg_icon;	
				}
			});
			if(getURLDetails[1]!=='settings' && getURLDetails[2] === arr.name){ 
				actClass = 'active'; 
				actClassMore= 'd-flex active align-items-center'; 
			}
			if(ii < props.showItems){
			   leftMenuData.push(
			   <LinkContainer to={arr.url} onClick={e => toggleSideBarClose2(0)} key={i}>
				   <li className={arr.class+' '+actClass} data-title={arr.name} to={arr.url}>
				   <a className="cursor-pointer" data-title={arr.name} >
						   {/* <Icons iconType={arr.icon} /> */}
						   {isSet(arr.window_icon,null)!==null?(!arr.system_icon?
									<img src={sourceImage}  width='18' height='18' />
									// <div className="Container" dangerouslySetInnerHTML={{__html: htmlCode}}></div>
								:<WindowIcons size={18}  windowIcon={arr.window_icon}/>):
							<Icons iconType={arr.icon} />
							} 

						   <div className="windowName"> {arr.name} </div>
					   </a>
				   </li>
			   </LinkContainer>
			   )
		   }else{
			   moreMenuData.push(
				   <LinkContainer to={arr.url} onClick={e => toggleSideBarClose2(0)} key={i+ii}>
					   <div className={`item ${actClassMore}`} to={arr.url} title={arr.name}>
						   {/* <Icons iconType={arr.icon} /> */}
						   {isSet(arr.window_icon,null)!==null?(!arr.system_icon?
									<img src={sourceImage}  width='18' height='18' />
									// <div className="Container" dangerouslySetInnerHTML={{__html: htmlCode}}></div>
								:<WindowIcons  size={18} windowIcon={arr.window_icon}/>):
							<Icons iconType={arr.icon} />
							} 
						   <span className="pl-2 text-truncate">{arr.name}</span>	
					   </div>
				   </LinkContainer>
			   )	
		   }
		   ii++;	
		});
		setLeftMenuData(leftMenuData);
		setLeftMoreMenuData(moreMenuData);
	}


	const toggleSideBar2  = () => {	
		if(toggleSideBarShow === false){
			$("#scripted").focus();	
			setToggleSideBarShow(true);
		}
		
	}

	const goToWindowList = async (param,props)=>{
		let userLayouts = [];
		const profileInfo = getProfileAuthorities();
		try{
			if(profileInfo!==undefined && profileInfo.data!==undefined && profileInfo!=='' && profileInfo.data!==''){			
				for(let index = 0; index < profileInfo.data.user_profile_layout.length; index++){
					const item = profileInfo.data.user_profile_layout[index];
					if(param.system_defined_name==="Pages Window"){
						if(param.org_window_id===item.org_window_id && item.is_active===true){
							// Check permission before loading pages configuration
							if(item?.pages_configuration_id){
								const hasPermission = await checkPagesConfigurationPermission(item.pages_configuration_id, props);
								if(!hasPermission){
									props.warningMessage("You don't have permission to access this page. Please contact your administrator.");
									return;
								}
							}
							props.clearHistoryPageFlowsAction();
							queueMicrotask(() => {
								props.loadPagesConfigAction('ID', item?.pages_configuration_id, { history: props.history });
							});
							toggleSideBarClose2(0);
						}
					}else if(param.window_id===item.window_id && item.is_active===true){ 
						// Check if layout has pages_configuration_id and verify permission
						// if(item?.pages_configuration_id){
						// 	const hasPermission = await checkPagesConfigurationPermission(item.pages_configuration_id, props);
						// 	if(!hasPermission){
						// 		props.warningMessage("You don't have permission to access this page. Please contact your administrator.");
						// 		return;
						// 	}
						// }
						clearGoBackURL();
						toggleSideBarClose2(0);
						userLayouts.push(item.layout_id);
						props.history.push("/layouts/"+param.window_name+"/"+param.window_id+"/list/"+item.layout_id+'/'+Math.floor(Math.random() * 100) + 1);
					}
				}
			}
		}catch(e){
			console.error('Error in goToWindowList:', e);
		}
	}

	// Check pages configuration permission
	const checkPagesConfigurationPermission = async (pagesConfigurationId, props) => {
		if(!pagesConfigurationId) return true;
		try {
			return await ProfileService.checkPagesConfigurationPermission(pagesConfigurationId);
		} catch(error) {
			console.error('Error checking pages configuration permission:', error);
			if(typeof props?.warningMessage === 'function') {
				props.warningMessage("You don't have permission to access this page. Please contact your administrator.");
			}
			return false;
		}
	}

	const toggleSideBarClose2 = (flag) => {
		if(flag === 0){
			setToggleSideBarShow(false);	
		}
	}

	const toggleSideBarOpen2 = () => {
		setToggleSideBarShow(true);	
	}
	const reminderListPopupToogle = (bool)=>{
		if(bool===true){
			$('.reminderNotifyBox').show();
		}else{
			$('.reminderNotifyBox').hide();
		}
	}

	// if(!toggleLeftMenuShow){
	// 	if($(".wrapper").hasClass("sidebar_minimize")){
	// 		setToggleLeftMenuShow(!toggleLeftMenuShow);
	// 		setTimeout(() => {
	// 			checkHight(!toggleLeftMenuShow);
	// 		}, 200);	
	// 	}	
	// }
	
	
	const menuDataHandler = async () => {
		const val = !toggleLeftMenuShow;
		if(val === true) {
			$(".wrapper").addClass("sidebar_minimize");
			setToggleSideBarShow(false);
		}else {
			$(".wrapper").removeClass("sidebar_minimize");
		}
		await setToggleLeftMenuShow(val);
		checkHight(val);
		
	}

	const checkHight = (val) => {
		const height = document.getElementById('sssssss').clientHeight;
		props.showItemsHanlder(height,val);
	}

	

	

	 let menuDataLength = leftMoreMenuData.length;
	 let ACTIVITY_REMINDER = {};
	 let activityReminder  = localStorage.getItem('ACTIVITY_REMINDER');
	 try{
		 if(activityReminder!==null && activityReminder!==undefined){
			 ACTIVITY_REMINDER =JSON.parse(activityReminder);
		 }
	 }catch(e){

	 }
	 let settingClass = (getURLDetails[1]==='settings')? 'active':'';
	
	//  console.log('userInfo',userInfo);
	return (

		<Wrp>
			<div className="sidebar sidebar-style-2">
				{/*logo*/}
				{/* <div className="logo"> */}
					<span className="toggleArrow" onClick={menuDataHandler}>
			 			{/*<button className="btn btn-toggle py-0" >  toggle-sidebar */}
			 				{
			 				toggleLeftMenuShow === false ?
			 				<i className="fas fa-angle-double-right" ></i>
			 				:
			 				<i className="fas fa-angle-double-left" ></i>
			 				}
			 			{/* </button> */}
					</span>
					{/* <span className="companyName" title={userDefaultMod}>
			 			{userDefaultMod}
					</span> */}
				{/* </div> */}
				{/*logo*/}

				{/*menu part*/}
				<div className="sideMenu" id="sssssss">
					<ul className="nav nav-primary" style={{paddingTop:'4rem'}}>
						{leftMenuData}

						<LinkContainer to="/settings">
							<li className={`nav-item tab_focus svgIconFill ${settingClass} `}  to="/settings">
								<a className="cursor-pointer" data-title="Settings">
									<Icons iconType="Settings" />
									<div className="windowName"> Settings </div>
								</a>
							</li>
						</LinkContainer>
					</ul>
					{ toggleSideBarShow===false?	
						menuDataLength > 0 ?
						<div className="nav nav-primary moreMenu svgIconFill">
						<div className="nav-item tab_focus">
							<a href="#" data-title="More Menu's" onClick={toggleSideBar2}>
								<div id="sideOpen"  >
									<Icons iconType="ActionMore" />
								</div>
							</a>
						</div>
						</div>
						: ''
						:
						menuDataLength > 0 ?
						<div className="nav nav-primary moreMenu">
						   <div className="nav-item tab_focus">
							   <a href="#" data-title="More Menu's`">
								   <Icons iconType="ActionMore" />
							   </a>
						   </div>
						   </div>					
						   : ''
						}
				</div>
				{/*menu part*/}

				<div className="bNotify">
					<a href="#" onClick={()=>reminderListPopupToogle(true)}>
						<Icons iconType="Reminder" />
					</a>
					<span className="notification">{Object.keys(ACTIVITY_REMINDER).length}</span>
				</div>
			</div>
			<div className="sidebar2" tabIndex="0" id="scripted" onBlur={e => toggleSideBarClose2(0)}>
				<div id="sideBox" className={toggleSideBarShow === true ? "active" : ""}> 
					<div id="sideClose" onClick={e => toggleSideBarClose2(0)} className={toggleSideBarShow === true ? "active" : ""}>
						<div id='top'></div>
						<div id='middle'></div>
						<div id='bottom'></div>
					</div>
					<div id="items">
						{leftMoreMenuData}	
					</div>
				</div>
			</div>
			<ReminderList 
				reminderListPopupToogle={reminderListPopupToogle}
				ACTIVITY_REMINDER={ACTIVITY_REMINDER}
				setReminderMessage={setReminderMessage}
				/>
		</Wrp>
	);
});

const mapDispatchToProps = (dispatch) => ({
	loadPagesConfigAction: (searchBy, configId, options) =>
		dispatch(loadPagesConfigAction(searchBy, configId, options)),
	clearHistoryPageFlowsAction: () => dispatch(clearHistoryPageFlowsAction()),
});

export default connect(
	null,
	mapDispatchToProps
)(withRouter(LeftNav));